import { useEffect, useState } from "react";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import { BrowserRouter, HashRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import TrustMarquee from "@/components/landing/TrustMarquee";
import Services from "@/components/landing/Services";
import Process from "@/components/landing/Process";
import WhyUs from "@/components/landing/WhyUs";
import BookingForm from "@/components/landing/BookingForm";
import Footer from "@/components/landing/Footer";
import Splash from "@/components/landing/Splash";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import BookPickup from "@/pages/BookPickup";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Landing() {
  const [splashDone, setSplashDone] = useState(
    () => sessionStorage.getItem("revanta-splash") === "1"
  );

  useEffect(() => {
    if (splashDone) return;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => {
      sessionStorage.setItem("revanta-splash", "1");
      document.body.style.overflow = "";
      setSplashDone(true);
    }, 2600);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = "";
    };
  }, [splashDone]);

  return (
    <div className="min-h-screen bg-white" data-testid="revanta-app">
      <AnimatePresence>{!splashDone && <Splash />}</AnimatePresence>
      {splashDone && (
        <>
          <Navbar />
          <main>
            <Hero />
            <TrustMarquee />
            <Services />
            <Process />
            <WhyUs />
            <BookingForm />
          </main>
          <Footer />
        </>
      )}
    </div>
  );
}

export default function App() {
  const Router = process.env.REACT_APP_SINGLE_FILE === "1" ? HashRouter : BrowserRouter;

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/book-pickup" element={<BookPickup />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
      </Routes>
      <Toaster position="bottom-right" richColors />
    </Router>
  );
}
